import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { useMatches } from 'react-router-dom';
import { getMatchRouteName } from '@cyberint/common-utils';
import { t } from '../i18n';
import { breadcrumbTitles } from '../store/breadcrumb-atoms';

export const useDocumentTitle = ({ getFallbackTitle } = {}) => {
  const matches = useMatches().filter(m => m.handle);
  const match = matches[matches.length - 1];
  const titles = useAtomValue(breadcrumbTitles);

  useEffect(() => {
    const routeName = titles[match?.pathname] || getMatchRouteName(match);
    const pageTitle = typeof routeName === 'string' ? routeName : getFallbackTitle?.(match);
    document.title = pageTitle ? `${pageTitle} | ${t('productName')}` : t('productName');
  }, [match, titles]);
};
